export default __webpack_public_path__ + "static/media/Q7-1.7d9342e2.jpg";